// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import store from './store/index'
import './router/filter'

import './assets/icones/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/element-variables.scss'
import './assets/styles/element-variables.scss'
import Styles from '@/assets/styles/application.scss';

import DictStore from './utils/dict-store'
import UserConfigStore from './utils/user-config-store'
import ObjectUtil from './utils/object-util'

import QuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.snow.css'

Vue.use(QuillEditor)

// ElementUI 默认参数配置
Vue.use(ElementUI)

Vue.config.productionTip = false;

Vue.prototype.DictStore = DictStore;
Vue.prototype.ObjectUtil = ObjectUtil;
Vue.prototype.UserConfigStore = UserConfigStore;
Vue.prototype.Styles = Styles;

Vue.prototype.FileBaseUrl = process.env.VUE_APP_BASEURL + "/file/";


/* eslint-disable no-new */
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
